module.exports = __webpack_public_path__ + "static/media/Hot dogs.ca2723fc.svg";